/*******************************************************************************
* @license (c)Copyright Since 2018, SOFTBANK Corp. All rights reserved.
*
*	機能概要	: Google Analytics処理
*	システム	: iTunesCDD
******************************************************************************/
'use strict';

$(document).ready(function () {
	// environment.js.j2からGA処理を呼び出すか判定するための情報を環境変数より取得
	var gaString = utility.getEnviromentInfo(gaList, environment_id);
	// GA実行判定
	if (gaString) {
		try{
			if (navigator.appVersion.toLowerCase().indexOf("msie 6.")==-1) {
			(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
			new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
			j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
			'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','GTM-BMSW');
			} 
		}catch(e){}
	}
});


var commonGA = {
	accessTracking: function (pageName) {
		window.dataLayer = window.dataLayer || [];
		dataLayer.push({
			'pageUrl': '/' + pageName + '.html',
			'event': 'olsEcFlow'
		});
	},
	/** 
	 * 商品選択画面のGA設定処理
	 * @param {json} data 画面の状態判定用パラメータ
	 */
	itemSelectGA: function (data) {
		var pageName	= '';		// 商品選択画面のGA情報
		if (data.ribon_label_string === commonGA.FIRST_PURCHASE_WORD) {// 初回購入
			pageName	= commonGA.ITEM_SELECT_FIRST;
			commonGA.accessTracking(commonGA.ITEM_SELECT_FIRST);
		} else if (data.ribon_label_string === commonGA.TIMESALE_PURCHASE_WORD) {// タイムセール
			pageName	= commonGA.ITEM_SELECT_TIMESALE;
			commonGA.accessTracking(commonGA.ITEM_SELECT_TIMESALE);
		} else {// 通常
			pageName = commonGA.ITEM_SELECT_NORMAL;
			commonGA.accessTracking(commonGA.ITEM_SELECT_NORMAL);
		}
		// エラー画面遷移時にGAを判断する情報がない為、
		// sessionStorageに現在の画面情報を保存
		commonGA.setSessionStorage('pageName', pageName);
	},
	/** 
	 * 申込内容確認画面のGA設定処理
	 * @param {json} data 画面の状態判定用パラメータ
	 * @param {string} couponFlag クーポン利用判定フラグ
	 */
	requestContentsConfirmGA: function (data, couponFlag) {
		var pageName	= '';		// 申込内容確認画面のGA情報
		var trackingKbn = '';		// 購入完了画面用GA判定区分
		if (data.ribon_label_string === commonGA.FIRST_PURCHASE_WORD) {// 初回購入
			pageName	= commonGA.CONFIRM_FIRST;
			trackingKbn = '0';
			commonGA.accessTracking(commonGA.CONFIRM_FIRST);
		} else if (data.ribon_label_string === commonGA.TIMESALE_PURCHASE_WORD) {// タイムセール
			pageName	= commonGA.CONFIRM_TIMESALE;
			trackingKbn = '1';
			commonGA.accessTracking(commonGA.CONFIRM_TIMESALE);
		} else {// 通常
			if (couponFlag) {// 通常でクーポーン利用時
				pageName	= commonGA.CONFIRM_COUPON;
				trackingKbn = '2';
				commonGA.accessTracking(commonGA.CONFIRM_COUPON);
			} else {// 通常でクーポン利用なし
				pageName	= commonGA.CONFIRM_NORMAL;
				trackingKbn = '3';
				commonGA.accessTracking(commonGA.CONFIRM_NORMAL);
			}
		}
		// エラー画面遷移時にGAを判断する情報がない為、
		// sessionStorageに現在の画面情報と購入完了画面用GA判定区分設定
		commonGA.setSessionStorage('pageName', pageName);
		commonGA.setSessionStorage('trackingKbn', trackingKbn);
	},
	
	/** 
	 * 購入完了画面のGA設定処理
	 * @param {string} trackingKbn GA状況判定区分
	 * 0:初回購入,1:タイムセール,2:通常(クーポン),3:通常
	 */
	purchaseCompleteGA: function (trackingKbn) {
		var pageName	= '';	// 申込内容確認画面のGA情報
		if (trackingKbn === '0') {// 初回購入
			pageName	= commonGA.FINISH_FIRST;
		} else if (trackingKbn === '1') {// タイムセール
			pageName	= commonGA.FINISH_TIMESALE;
		} else if (trackingKbn === '2') {// 通常でクーポーン利用時
			pageName	= commonGA.FINISH_COUPON;
		} else {// 通常でクーポン利用なし
			pageName	= commonGA.FINISH_NORMAL;
		}
		// エラー画面遷移時にGAを判断する情報がない為、
		// sessionStorageに現在の画面情報を保存
		commonGA.setSessionStorage('pageName', pageName);
	},

	/** 
	 * 購入完了画面のEC設定処理
	 * @param {json} data 購入リクエスト情報
	 * {
	 *		accept_number		: XXXX
	 *		charge_amount	: XXXX
	 *		pay_amount		: XXXX
	 *		itunes_code		: XXXX
	 *		itunes_code_issue_flag : XXXX
	 *		product_code		: XXXX
	 *		product_name		: XXXX
	 *		product_category	: XXXX
	 *		product_variant	: XXXX
	 *		coupon_code		: XXXX
	 * }
	 * <説明>
	 * @param {string}	accept_number		受付番号（GA用） 
	 * @param {int}		charge_amount	チャージ金額（画面表示用）
	 * @param {int}		pay_amount		支払い金額（GA用）
	 * @param {string}	itunes_code		iTunesコード（GA & 画面表示用） 
	 * @param {boolean}  itunes_code_issue_flag  コード発行中かどうかを判断するフラグ (画面表示用)
	 * @param {string}	product_code		商品コード(GA用) 
	 * @param {string} product_name		商品名（GA用） 
	 * @param {string} product_category	商品カテゴリ（GA用） 
	 * @param {string} product_variant	商品バリアント（GA用） 
	 * @param {string} coupon_code		クーポンコード（GA用） 
	 */
	ecommerceGA: function (data) {
		var pageName = sessionStorage.getItem('pageName');

		var brand = 'App Store & iTunes ギフトカード';
		if (data.apple_card_show) {
			brand = 'Apple Gift Card';
		}

		window.dataLayer = window.dataLayer || [];
		dataLayer.push({
			'pageUrl': '/' + pageName + '.html',
			'ecommerce': {
				'purchase': {
					'actionField': {
						'id': data.accept_number,
						'affiliation': 'NEWOLS',
						'revenue': `${utility.removeComma(data.pay_amount)}`,
						'tax':'0',
						'shipping': '0',
						'coupon': data.coupon_code
					},
					'products': [{
						'id': 'ITDDAPACB9',
						'name': data.product_name,
						'price': `${utility.removeComma(data.pay_amount)}`,
						'brand': brand,
						'category': data.product_category,
						'variant': data.product_variant,
						'quantity': 1
					}]
				}
			},
			'event': 'olsEcCV'
		});
	},
	/** 
	 * GA情報セッション設定処理
	 * @param {string} key sessionStorageに保存するkey
	 * @param {string} value sessionStorageに保存するvalue
	 */
	setSessionStorage: function (key, value) {
		if (!window.sessionStorage) return;
		try {
			sessionStorage.setItem(key, value);
		} catch (err) {
			return false;
		}
	}
}
/***********************************/
/******* Google Analytics定数 *******/
/***********************************/
Object.defineProperties(commonGA, {
	/* 商品選択用 START */
    /**
     * GoogleAnalytics商品選択画面初回購入用パラメータ<br>
     * @type {String}<br>
     */
    ITEM_SELECT_FIRST : {
        value : 'ITDD_SMP_sales.chooseItunesCd.first',
        enumerable : true,
        writable : false
    },
    /**
     * GoogleAnalytics商品選択画面タイムセール用パラメータ<br>
     * @type {String}<br>
     */
    ITEM_SELECT_TIMESALE : {
        value : 'ITDD_SMP_sales.chooseItunesCd.timesale',
        enumerable : true,
        writable : false
    },
    /**
     * GoogleAnalytics商品選択画面通常用パラメータ<br>
     * @type {String}<br>
     */
    ITEM_SELECT_NORMAL : {
        value : 'ITDD_SMP_sales.chooseItunesCd',
        enumerable : true,
        writable : false
    },
	/* 商品選択用 END */
	/* 申込内容確認用 START */
    /**
     * GoogleAnalytics申込内容確認画面初回購入用パラメータ<br>
     * @type {String}<br>
     */
    CONFIRM_FIRST : {
        value : 'ITDD_SMP_sales.confirm.first',
        enumerable : true,
        writable : false
    },
    /**
     * GoogleAnalytics申込内容確認画面タイムセール用パラメータ<br>
     * @type {String}<br>
     */
    CONFIRM_TIMESALE : {
        value : 'ITDD_SMP_sales.confirm.timesale',
        enumerable : true,
        writable : false
    },
    /**
     * GoogleAnalytics申込内容確認画面通常用パラメータ<br>
     * @type {String}<br>
     */
    CONFIRM_NORMAL : {
        value : 'ITDD_SMP_sales.confirm',
        enumerable : true,
        writable : false
    },
    /**
     * GoogleAnalytics申込内容確認画面通常(クーポン)用パラメータ<br>
     * @type {String}<br>
     */
    CONFIRM_COUPON : {
        value : 'ITDD_SMP_sales.confirm_coupon',
        enumerable : true,
        writable : false
    },
	/* 申込内容確認用 END */
	/* 購入完了確認用 START */
    /**
     * GoogleAnalytics購入完了画面初回購入用パラメータ<br>
     * @type {String}<br>
     */
    FINISH_FIRST : {
        value : 'ITDD_SMP_sales.finish.first',
        enumerable : true,
        writable : false
    },
    /**
     * GoogleAnalytics購入完了画面タイムセール用パラメータ<br>
     * @type {String}<br>
     */
    FINISH_TIMESALE : {
        value : 'ITDD_SMP_sales.finish.timesale',
        enumerable : true,
        writable : false
    },
    /**
     * GoogleAnalytics購入完了画面通常用パラメータ<br>
     * @type {String}<br>
     */
    FINISH_NORMAL : {
        value : 'ITDD_SMP_sales.finish',
        enumerable : true,
        writable : false
    },
    /**
     * GoogleAnalytics購入完了画面通常(クーポン)用パラメータ<br>
     * @type {String}<br>
     */
    FINISH_COUPON : {
        value : 'ITDD_SMP_sales.finish_coupon',
        enumerable : true,
        writable : false
    },
	/* 購入完了確認用 END */
    /**
     * GoogleAnalyticsエラー時の接尾語<br>
     * @type {String}<br>
     */
    ERROR_GA_SUFFIX : {
        value : '.error',
        enumerable : true,
        writable : false
    },
    
    /**
     * GoogleAnalytics処理分岐文言：初回購入<br>
     * @type {String}<br>
     */
    FIRST_PURCHASE_WORD : {
        value : '初回購入',
        enumerable : true,
        writable : false
    },
    /**
     * GoogleAnalytics処理分岐文言：初回購入<br>
     * @type {String}<br>
     */
    TIMESALE_PURCHASE_WORD : {
        value : 'タイムセール',
        enumerable : true,
        writable : false
    }
});
